import { create } from "zustand";

// GitHub PAT for sync. Per-user, localStorage — same shape as the
// BabyAI/Anthropic keys. One PAT spans all sync-enabled channels.
//
// PAT scope needed: `repo` (private repos) or `public_repo` (public).
// Fine-grained tokens with "Contents: Read and write" on the target
// repos also work.

const STORAGE_GITHUB = "playground.github_token";

function load(): string | null {
  if (typeof localStorage === "undefined") return null;
  return localStorage.getItem(STORAGE_GITHUB);
}

type GitHubState = {
  token: string | null;
  setToken: (token: string) => void;
  clearToken: () => void;
};

export const useGitHubStore = create<GitHubState>((set) => ({
  token: load(),
  setToken: (token) => {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(STORAGE_GITHUB, token);
    }
    set({ token });
  },
  clearToken: () => {
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem(STORAGE_GITHUB);
    }
    set({ token: null });
  },
}));
